import { render, staticRenderFns } from "./UnlockUpgrade.vue?vue&type=template&id=23356120&scoped=true"
import script from "./UnlockUpgrade.vue?vue&type=script&lang=js"
export * from "./UnlockUpgrade.vue?vue&type=script&lang=js"
import style0 from "./UnlockUpgrade.vue?vue&type=style&index=0&id=23356120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23356120",
  null
  
)

export default component.exports